import { id as idLocale } from 'date-fns/locale';
import { format } from 'date-fns';


const dateFormatter = (date, stringFormat) => {
  let value = "";
  try {
    value = format(date ? date : new Date(), stringFormat, {
      locale: idLocale,
    });
  } catch (e) {
    value = format(date ? date.toDate() : new Date(), stringFormat, {
      locale: idLocale,
    });
  }

  return value;
};

const educationTransition = (delay) => ({
  type: "spring",
  delay: delay,
  duration: 1,
});

export {
	dateFormatter, educationTransition
}
